import { Injectable } from "@angular/core";
import { QQQuestionViewModel } from "../models/qq-question.view-model";
import { ApiService } from "./api.service";
import { InterpolationService } from "./interpolation.service";
import { CalculationService } from "./calculation.service";

@Injectable({
  providedIn: 'root'
})
export class QuestionService {

  constructor(
    private api: ApiService,
    private interpolator: InterpolationService,
    private calculator: CalculationService
  ) {
  }

  createQuestion(
    key: string,
    type: 'Select' | 'Numeric',
    label: string,
    options: {
      condition?: string,
      hasValidations?: boolean,
      helpKey?: string,
      id?: string,
      options?: any,
      tip?: string
    }
  ) {
    return new QQQuestionViewModel(
      {
        key,
        type,
        label,
        condition: options.condition ?? null,
        hasValidations: options.hasValidations ?? false,
        helpKey: options.helpKey,
        id: options.id ?? key,
        options: options.options,
        tip: options.tip ?? null
      },
      this.api,
      null
    );

  }

  getCalculatedOptions(question: QQQuestionViewModel) {
    let opts = { ...question.options };
    if (question.options.calculate)
      for (const key of Object.keys(question.options.calculate)) {
        if (key === 'tip') {
          question.tip = this.interpolator.interpolate(question.options.calculate.tip, opts);
        } else {
          const value = this.calculator.calculate(question.options.calculate[key], question.page.questionnaire);
          opts[key] = value;
        }
      }
    return opts;
  }

}
